var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.active)?_c('v-overlay',{attrs:{"absolute":_vm.absolute,"color":_vm.overlayColor}},[_vm._t("text"),_c('v-progress-circular',{attrs:{"size":_vm.size,"width":_vm.width,"color":_vm.color,"indeterminate":_vm.indeterminate}})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }